import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLetterZCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"letter-z-circle"} maskId="square-filled-radius-0-stroke-1-IconLetterZCircle"><path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM9.03516 7.77246V8.72168H13.6582V8.81543L8.87109 15.4775V16.2275H15.123V15.2783H10.2598V15.1846L15.0234 8.52246V7.77246H9.03516Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLetterZCircle;
